import React, { useState, useEffect } from 'react';
import './Podium.css'; 
import { Link, useNavigate } from 'react-router-dom';
import defaultPicture from "../assets/default_pfp.png";


const PodiumComponent = () => {

    const [members, setMembers] = useState([]);


    const fetchUsersWithXP = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_PATH}/users`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                },
            });
    
            if (!response.ok) {
                throw new Error(`Failed to fetch users: ${response.status} ${response.statusText}`);
            }
    
            const responseData = await response.json();
    
            if (!Array.isArray(responseData) || responseData.length === 0) {
                throw new Error('Invalid response format: users array is missing or empty');
            }
    
            const usersArray = responseData[0];
    
            const usersWithFind = usersArray.filter(user => user.attributes && user.attributes.exp && user.attributes.username);

            usersWithFind.sort((a, b) => {
                return b.attributes.exp - a.attributes.exp;
            });
  
            setMembers(usersWithFind);
            console.log(usersWithFind);
    
        } catch (error) {
            console.error('Error fetching users:', error.message);
            alert(`Failed to fetch users: ${error.message}`);
        }
    };
    
    useEffect(() => {
        fetchUsersWithXP();
    }, []);
    
    return (
        <div className="podium-section">
          <div className="scoreboard">
            <div className="scoreboard__podiums">
              <div className="scoreboard__podium">
                <div className="scoreboard__podium-base scoreboard__podium-base--second">
                  <div className="scoreboard__bar">
                    {members.length > 0 && members[1] && (
                      <Link to={`/user/${members[1].id}`} style={{ textDecoration: 'none' }}>
                        {members[1].attributes.picture !== "" ? (
                          <img src={members[1].attributes.picture} alt="Profile" className="scoreboard__profile-picture" />
                        ) : (
                          <img src={defaultPicture} alt="Default Profile" className="scoreboard__profile-picture" />
                        )}
                      </Link>
                    )}
                  </div>
                  <div className="scoreboard__podium-rank"></div>
                </div>
                <div className="scoreboard__podium-number">@{members.length > 0 && members[1].attributes.username}</div>
              </div>
              <div className="scoreboard__podium">
                <div className="scoreboard__podium-base scoreboard__podium-base--first">
                  <div className="scoreboard__bar">
                    {members.length > 0 && members[0] && (
                      <Link to={`/user/${members[0].id}`} style={{ textDecoration: 'none' }}>
                        {members[0].attributes.picture !== "" ? (
                          <img src={members[0].attributes.picture} alt="Profile" className="scoreboard__profile-picture" />
                        ) : (
                          <img src={defaultPicture} alt="Default Profile" className="scoreboard__profile-picture" />
                        )}
                      </Link>
                    )}
                  </div>
                  <div className="scoreboard__podium-rank"></div>
                </div>
                <div className="scoreboard__podium-number">@{members.length > 0 && members[0].attributes.username}</div>
              </div>
              <div className="scoreboard__podium">
                <div className="scoreboard__podium-base scoreboard__podium-base--third">
                  <div className="scoreboard__bar">
                    {members.length > 0 && members[2] && (
                      <Link to={`/user/${members[2].id}`} style={{ textDecoration: 'none' }}>
                        {members[2].attributes.picture !== "" ? (
                          <img src={members[2].attributes.picture} alt="Profile" className="scoreboard__profile-picture" />
                        ) : (
                          <img src={defaultPicture} alt="Default Profile" className="scoreboard__profile-picture" />
                        )}
                      </Link>
                    )}
                  </div>
                  <div className="scoreboard__podium-rank"></div>
                </div>
                <div className="scoreboard__podium-number">@{members.length > 0 && members[2].attributes.username}</div>
              </div>
            </div>
          </div>
        </div>
      );
};

export default PodiumComponent;
